module.exports = __webpack_public_path__ + "static/media/carousel-3.f46096f5.jpg";